// extracted by mini-css-extract-plugin
export default {"root":"controls-bar-space_root__JcqD4","placeHolderShimmer":"controls-bar-space_placeHolderShimmer__wc045"};